import { StepConnector, stepConnectorClasses } from '@mui/material';
import { styled } from '@mui/material/styles';


const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#EAE9EA', // Custom color for active step line
      borderStyle: 'dashed',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#EAE9EA', // Custom color for completed step line
      borderStyle: 'dashed',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#EAE9EA', // Default color
    borderTopWidth: 2,
    borderRadius: 1,
    BorderStyle:'dashed',
  },
}));

export default CustomStepConnector;
